/* eslint-disable */
var $ = window.jQuery = require('jquery');

import draggable from "vuedraggable";
import {
  mapGetters
} from 'vuex';

export default {
  name: 'public-quiz-category',
  components: {
    draggable
  },
  props: [],
  data() {
    return {
      categoryList: null,
      categoryListRslt:[]
    }
  },
  computed: {
    ...mapGetters([
      'getCategoriesListGetters',
    ]),
    getCategory() {
      this.categoryList = this.$store.getters.getCategoriesListGetters.data;
      return;
    },
    setInitialStatesFun(){
      if(this.categoryList){
        this.categoryListRslt = this.categoryList.data
      }
      return;
    }
  },
  mounted() {
    this.getCategory
    this.setInitialStatesFun
  },
  methods: {
  },
  watch: {
    getCategory() {
      return this.$store.getters.getCategoriesListGetters;
    },
    setInitialStatesFun(){
      if(this.categoryList){
        this.categoryListRslt = this.categoryList.data
      }
      return;
    }
  }
}